import React from 'react';
import styles from '../view.module.css';

const ContactCard = ({
  contact,
  featured = false,
  is_key = false,
  onMakeKey = () => {},
  onEdit = () => {}
}) => {
  const name = [contact.first_name, contact.last_name].filter(Boolean).join(' ') || '—';
  const hasEmail = Boolean(contact.email);
  const hasPhone = Boolean(contact.phone);
  const hasLinkedIn = Boolean(contact.linkedin_url);
  const hasAny = hasEmail || hasPhone || hasLinkedIn;

  return (
    <div
      className={`${styles.contactCard} ${featured ? styles.contactCardFeatured : ''} ${
        is_key ? styles.contactCardKey : ''
      }`}
    >
      <div className={styles.contactInfo}>
        <div className={styles.contactNameRow}>
          <span className={styles.contactName}>{name}</span>
          {is_key ? <span className={styles.keyContactBadge}>★</span> : null}
        </div>
        {is_key && !hasEmail && (
          <span className={styles.keyContactWarning}>
            No email — meeting reminders won&apos;t be delivered
          </span>
        )}
        {contact.title && <div>{contact.title}</div>}
        {hasAny ? (
          <div className={styles.contactDetails}>
            {hasEmail && (
              <div>
                <a className={styles.contactDetailLink} href={`mailto:${contact.email}`}>
                  <svg width="11" height="11" viewBox="0 0 16 16" fill="currentColor">
                    <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2zm13 2.383-4.708 2.825L15 11.105V5.383zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741zM1 11.105l4.708-2.897L1 5.383v5.722z" />
                  </svg>
                  - {contact.email}
                </a>
              </div>
            )}
            {hasPhone && (
              <div>
                <a className={styles.contactDetailLink} href={`tel:${contact.phone}`}>
                  <svg width="11" height="11" viewBox="0 0 16 16" fill="currentColor">
                    <path
                      fillRule="evenodd"
                      d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"
                    />
                  </svg>
                  - {contact.phone}
                </a>
              </div>
            )}
            {hasLinkedIn && (
              <div>
                <a
                  className={styles.contactDetailLink}
                  href={contact.linkedin_url}
                  target="_blank"
                  rel="noreferrer"
                >
                  <svg width="11" height="11" viewBox="0 0 16 16" fill="currentColor">
                    <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z" />
                  </svg>
                  - LinkedIn
                </a>
              </div>
            )}
          </div>
        ) : (
          <span className={styles.contactNoInfo}>No contact details</span>
        )}

        <div className={styles.contactCardActions}>
          <button type="button" className={styles.editContactBtn} onClick={() => onEdit(contact)}>
            Edit
          </button>
          {!is_key && (
            <button type="button" className={styles.makeKeyBtn} onClick={() => onMakeKey(contact)}>
              Make key contact
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactCard;
